/* eslint-disable no-param-reassign, no-return-assign, no-cond-assign */

import {matchPath} from 'react-router';

const German = 'de';
const English = 'en';
const Spanish = 'es';
const French = 'fr';
const Italian = 'it';
const Dutch = 'nl';
const Danish = 'da';

export const Language = {
    German,
    English,
    Spanish,
    French,
    Italian,
    Dutch,
    Danish,
};

const Languages = [
    German,
    English,
    Spanish,
    French,
    Italian,
    Dutch,
    Danish,
];

export const DefaultLanguage = English;

export const validateLanguage = (language = DefaultLanguage) => (
    Languages.includes(language = language.toLowerCase()) ? language : DefaultLanguage
);

export const getLanguage = pathname => {
    const match = matchPath(pathname, '/:language/');

    if (match) return validateLanguage(match.params.language);

    return DefaultLanguage;
};
